
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTideLow as ObiTideLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-tide-low.js';
 
 
 

 
 export const ObiTideLow = createComponent({
   react: React,
   tagName: 'obi-tide-low',
   elementClass: ObiTideLowElement,
   events: {
     
   }
  });
 
 